<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
// import { useRoute } from 'vue-router';
// const route = useRoute();
//JSON.parse(decodeURIComponent(route.query.benefitsList))

const benefitsList = [
    {
        "title": "生存保險金",
        "order": [
            {
                "title": "第一順位",
                "isEqual": false,
                "order": [
                    {
                        isComplete: true,
                        fields: [
                            {
                                "id": "name",
                                "name": "姓名",
                                "key": "姓名",
                                "placeholder": "請填寫姓名",
                                "value": "AA",
                                "CheckVisible": false
                            },
                            {
                                "id": "id",
                                "name": "身分證字號",
                                "key": "身分證字號",
                                "placeholder": "請輸入身分證字號",
                                "value": "0123456789"
                            },
                            {
                                "id": "country",
                                "name": "國籍",
                                "key": "國籍",
                                "value": "中華民國",
                                "disabled": true
                            },
                            {
                                "id": "birthday",
                                "name": "出生日期",
                                "key": "出生日期",
                                "placeholder": "請輸入出生日期",
                                "type": "text",
                                "value": "90/01/01"
                            },
                            {
                                "id": "relation",
                                "name": "與被保險人的關係",
                                "key": "與被保險人的關係",
                                "placeholder": "請選擇與被保險人的關係",
                                "type": "select",
                                "options": [
                                    "祖父母",
                                    "外祖父母",
                                    "父母親",
                                    "子女"
                                ],
                                "value": "祖父母"
                            },
                            {
                                "id": "account",
                                "name": "受益人匯款帳號 (非必填)",
                                "key": "受益人匯款帳號",
                                "type": "bankAccount",
                                "value": {
                                    "bankCode": "012 AAAA",
                                    "bankBranch": "BBBBB",
                                    "bankAccount": "CCCCC"
                                }
                            },
                            {
                                "id": "ratio",
                                "name": "分配比例",
                                "key": "受益人分配比例",
                                "placeholder": "請填寫分配比例",
                                "value": "100%",
                                "isVisible": false
                            },
                            {
                                "id": "open",
                                "key": "開啟/縮合",
                                "value": true,
                                "CheckVisible": false,
                                "isVisible": false
                            }
                        ]
                    }
                    ,
                ]
            },
        ]
    },
    {
        "title": "滿期保險金",
        "order": []
    },
    {
        "title": "身故保險金",
        "order": []
    }
];

const goNextPage = () => {
    console.log('Go! Go! Go!');
}



//是否以電子文件寄送本次變更批註內容 checkbox
const checkboxAgree = ref('');


const getCaseBox = (ary) => {

    // console.log(ary);
    const _obj = {
        boxList: [],
    };

    ary.forEach(element => {

        // console.log(element);
        _obj.boxList.push({
            title: element.fields.find(item => item.id === 'name').value,
            list: element.fields.filter(item => item.CheckVisible !== false)
            // [
            //     { key: '申請日期', value: '113/06/15', },
            // ]
        });

    });

    return _obj;

}










</script>

<template>

    <Layout :header="{ text: '受益人變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫內容', '確認資料', '手機驗證',]" :index="2"></Process>
        </div>

        <div class="pb-4 flex justify-between items-center">
            <h2 class="font-bold text-2xl">確認以下已填寫資料</h2>
            <div class=" text-[#0093C1] textsm">
                <router-link :to="{ name: '' }">
                    <svg class="inline-block" fill="#0093C1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        viewBox="0 0 24 24">
                        <title>square-edit-outline</title>
                        <path
                            d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" />
                    </svg>修改
                </router-link>
            </div>
        </div>

        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">申請保單</h3>
            <CaseBox :caseBox="{ key: '1068302189-00', value: 'XWS5 富邦人壽新平準終身壽險', }"></CaseBox>
        </div>

        <div class="pb-4">
            <div :class="{ 'pt-6': i !== 0 }" v-for="(typeItem, i) in benefitsList">
                <h3 class="font-bold text-xl pb-4">{{ typeItem.title }}</h3>

                <template v-for="orderList in typeItem.order">
                    <h3 class="font-bold text-md pb-4" v-if="typeItem.order.length !== 1">{{ orderList.title }}</h3>
                    <CaseBox :caseBox="getCaseBox(orderList.order)"></CaseBox>
                </template>

            </div>
        </div>


        <div class="pb-4">
            <h4 class="font-bold text-lg pb-3">是否以電子文件寄送本次變更批註內容</h4>
            <label class="flex">
                <div class="pt-1 pr-3">
                    <input class="w-[20px] h-[20px] " type="checkbox" value="agree" v-model="checkboxAgree">
                </div>
                <p class="flex-1">
                    本人（即要保人）同意本次變更完成後，貴公司將批註內容以電子文件寄送至本次填寫或本人留存於貴公司最近一筆電子郵件信箱；未提供電子郵件信箱或郵件遭退回，則發送簡訊通知，若未留存行動電話或簡訊通知亦遭退回，則貴公司改以紙本寄送予本人。
                </p>
            </label>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>